import { render, staticRenderFns } from "./JianzhiBianji.vue?vue&type=template&id=999a4ff6&"
import script from "./JianzhiBianji.vue?vue&type=script&lang=js&"
export * from "./JianzhiBianji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./JianzhiBianji.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=Yangshi.css"
if (typeof block0 === 'function') block0(component)

export default component.exports